import React, { PureComponent } from 'react';
import { Skeleton, Summary } from 'components/common';
import CollectionInfo from 'components/Collection/CollectionInfo';
import CollectionStatus from 'components/Collection/CollectionStatus';
// import CollectionReference from 'components/Collection/CollectionReference';
import { Icon } from "@blueprintjs/core";

import './CollectionMetadataPanel.scss';
import axios from "axios";

class CollectionMetadataPanel extends PureComponent {

  constructor(props) {
    super(props);
    this.state = {
      collection_data: null, // Store collection data from API
      isLoading: true,  // Loading state for API call
    };
  }

  async componentDidMount() {
    // Extract collection_id from URL
    const urlPath = window.location.pathname; // e.g., /investigations/4
    const collectionId = urlPath.split("/").pop(); // Extract "4"

    if (collectionId) {
      await this.fetchCollectionData(collectionId);
    }
  }

  async fetchCollectionData(collectionId) {
    try {
      // Make API call to fetch collection data
      const response = await axios.get(
        `http://128.199.211.238:5000/api/2/externals?collection_id=${collectionId}`
      );
      // Update state with API response
      this.setState({ collection_data: response.data, isLoading: false });
    } catch (error) {
      this.setState({ collection_data: null, isLoading: false });
    }
  }

  renderSkeleton() {
    return (
      <div className="CollectionMetadataPanel">
        <Skeleton.Text
          type="div"
          length="75"
          className="CollectionMetadataPanel__item"
        />
        <Skeleton.Text
          type="div"
          length="100"
          className="CollectionMetadataPanel__item"
        />
        <Skeleton.Text
          type="div"
          length="200"
          className="CollectionMetadataPanel__item"
        />
      </div>
    );
  }

  render() {
    const { collection } = this.props;
    const { collection_data, isLoading } = this.state;
    if (!collection?.id) {
      return this.renderSkeleton();
    }

    return (
      <div className="CollectionMetadataPanel">
        <CollectionStatus
          collection={collection}
          showCancel={collection.writeable}
          className="CollectionMetadataPanel__item"
        />
        {collection.summary && (
          <div className="CollectionMetadataPanel__item">
            <Summary text={collection.summary} />
          </div>
        )}
        <div className="CollectionMetadataPanel__item">
          <CollectionInfo collection={collection} />
        </div>
        {/* <div className="CollectionMetadataPanel__item mobile-hide">
          <CollectionReference collection={collection} />
        </div> */}
        {isLoading === false && collection_data !== null && (
          <div className="CollectionMetadataPanel__item mobile-hide">
            <a
                href={collection_data.project_reference_url}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                    textDecoration: "none",
                    color: "#106ba3", // Blueprint primary color
                    display: "flex",
                    alignItems: "center",
                }}
            >
                <Icon icon="briefcase" style={{ marginRight: "8px" }} />
                กลับไปหน้าจัดการเคส
            </a>
          </div>
        )}
      </div>
    );
  }
}

export default CollectionMetadataPanel;
